import { css } from '@emotion/react';
import {
  type FC, type ReactNode,
} from 'react';
import type { Theme } from '~/_shared/themes/theme.model';

const wrapperStyle = ({ isLast }: { isLast: boolean }) => (theme: Theme) => css({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: theme.backgroundColors.secondary,
  borderRadius: `0 0 ${isLast ? '4px 4px' : '0 0'}`,
  borderTop: `1px solid ${theme.lineColors.basePrimary}`,
  boxSizing: 'border-box',
  fontSize: 10,
  height: 44,
  paddingRight: 10,
  width: '100%',

  '&:hover': {
    background: theme.buttonColors.primaryBackground,
    color: theme.textColors.quaternary,
  },
});

const titleStyle = css({
  marginLeft: 10,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

type SettingsAccordionDropDownOptionComponentProps = Readonly<{
  isLast: boolean;
  title?: string;
  children?: ReactNode;
  onChange: () => void;
}>;

export const SettingsAccordionDropDownOptionComponent: FC<SettingsAccordionDropDownOptionComponentProps> = (props) => {
  const { isLast, onChange } = props;

  return (
    <div
      css={wrapperStyle({ isLast })}
      onClick={onChange}
    >
      {props.children}
      {props.title && (
        <div css={titleStyle}>{props.title}</div>
      )}
    </div>
  );
};
